import { IIndexable } from 'core-ts-types';
import { merge } from 'lodash4';
import { IScheduleCourses } from '../types/my_schedule_types';
import { ScheduleSectionLabels } from './schedule_labels_builder';
import { ScheduleSectionTime } from './section_time_builder';

export class ScheduleSection implements IIndexable {
  id: number;
  nk: string;
  cd: string;
  course: number;
  campus: number;
  section_type?: any;
  seats_offered: number;
  instructor_name: string;
  class_start_dt: moment.Moment;
  class_end_dt: moment.Moment;
  drop_start_dt: moment.Moment;
  drop_end_dt: moment.Moment;
  is_unlimited_seating: boolean;
  note?: string;
  term: number;
  _course: IScheduleCourses;
  _displayData: any[];
  _sectionTime: ScheduleSectionTime[];
  _sectionLabels: ScheduleSectionLabels[];

  constructor(schedule: Partial<ScheduleSection>) {
    schedule.class_start_dt = moment(schedule.class_start_dt as moment.Moment);
    schedule.class_end_dt = moment(schedule.class_end_dt as moment.Moment);
    schedule.drop_start_dt = moment(schedule.drop_start_dt as moment.Moment);
    schedule.drop_end_dt = moment(schedule.drop_end_dt as moment.Moment);
    merge(this, schedule);
  }

  static build(schedule: Partial<ScheduleSection>): ScheduleSection {
    return new ScheduleSection(schedule);
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-course-schedule/src/builders/schedule_section_builder.ts